import { useEffect, useLayoutEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import RoutePending from './RoutePending';
import '../components/sidebar.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const [leftPanelExpanded, setLeftPanelExpanded] = useState(false);
  const [leftPanelWidthPx, setLeftPanelWidthPx] = useState(null);

  const syncLeftPanel = () => {
    const panel = document.querySelector('.leftMobile');
    if (!panel) return;

    const container = panel.closest('[data-resizable].common-direction');

    panel.classList.toggle('left-expanded', leftPanelExpanded);

    if (!leftPanelExpanded) {
      ['width', 'flex', 'max-width', 'min-width'].forEach((prop) => {
        panel.style.removeProperty(prop);
      });
      if (container) {
        container.style.removeProperty('--left-panel-width');
      }
      return;
    }

    if (container && leftPanelWidthPx != null) {
      container.style.setProperty('--left-panel-width', `${leftPanelWidthPx}px`);
    }
  };

  // Layout survives route changes; each page mounts a fresh .leftMobile.
  // Re-apply the user's open/closed choice before paint (no flash).
  useLayoutEffect(() => {
    syncLeftPanel();
  }, [location.pathname, leftPanelExpanded, leftPanelWidthPx]);

  useEffect(() => {
    const handleSwitch3Click = (e) => {
      if (!e.target.closest('.switch3')) return;
      setLeftPanelExpanded((prev) => !prev);
    };

    const handlePanelExpandedByResize = () => {
      setLeftPanelExpanded(true);
    };

    const handlePanelCollapsedByResize = () => {
      setLeftPanelExpanded(false);
    };

    const handlePanelWidthChanged = (e) => {
      const widthPx = e.detail?.widthPx;
      if (widthPx != null) {
        setLeftPanelWidthPx(widthPx);
      }
    };

    const handlePanelsReady = () => {
      syncLeftPanel();
    };

    document.addEventListener('click', handleSwitch3Click);
    window.addEventListener('left-panel-expanded', handlePanelExpandedByResize);
    window.addEventListener('left-panel-collapsed', handlePanelCollapsedByResize);
    window.addEventListener('left-panel-width-changed', handlePanelWidthChanged);
    window.addEventListener('resizable-panels-ready', handlePanelsReady);
    return () => {
      document.removeEventListener('click', handleSwitch3Click);
      window.removeEventListener('left-panel-expanded', handlePanelExpandedByResize);
      window.removeEventListener('left-panel-collapsed', handlePanelCollapsedByResize);
      window.removeEventListener('left-panel-width-changed', handlePanelWidthChanged);
      window.removeEventListener('resizable-panels-ready', handlePanelsReady);
    };
  }, [leftPanelExpanded, leftPanelWidthPx]);

  const contentLeftOffset =
    leftPanelExpanded && leftPanelWidthPx != null
      ? `${leftPanelWidthPx}px`
      : leftPanelExpanded
        ? '41.666667%'
        : '68px';

  return (
    <div style={{ display: 'flex', height: '100dvh', overflow: 'hidden' }}>
      <Sidebar />
      <div
        style={{
          flex: 1,
          overflow: 'hidden',
          '--content-left-offset': contentLeftOffset,
        }}
      >
        <RoutePending loaderArea="main">{children}</RoutePending>
      </div>
    </div>
  );
};

export default Layout;
